import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-program-hcp',
  templateUrl: 'program-hcp.html',
})
export class ProgramHcpPage {

  data: any[] = [
    {
      "period": "May-16",
      "receipts": 2,
      "total": 15259.35,
      "paid_by_insurers": 12204.28,
      "copay": 3055.07,
      "paid_by_patient": 371.02,
      "paid_by_eisai": 2684.05
    },
    {
      "period": "Jun-16",
      "receipts": 6,
      "total": 45915.68,
      "paid_by_insurers": 34525.62,
      "copay": 11390.06,
      "paid_by_patient": 1459.04,
      "paid_by_eisai": 9931.02
    },
    {
      "period": "Jul-16",
      "receipts": 14,
      "total": 102644.07,
      "paid_by_insurers": 89056.35,
      "copay": 13587.72,
      "paid_by_patient": 1212.7,
      "paid_by_eisai": 12375.02
    },
    {
      "period": "Aug-16",
      "receipts": 6,
      "total": 46407.82,
      "paid_by_insurers": 43301.32,
      "copay": 3106.5,
      "paid_by_patient": 185.83,
      "paid_by_eisai": 2920.67
    },
    {
      "period": "Sep-16",
      "receipts": 6,
      "total": 44046.94,
      "paid_by_insurers": 37861.88,
      "copay": 6185.06,
      "paid_by_patient": 557.49,
      "paid_by_eisai": 5627.57
    },
    {
      "period": "Oct-16",
      "receipts": 4,
      "total": 30061.35,
      "paid_by_insurers": 29348.92,
      "copay": 712.43,
      "paid_by_patient": 0,
      "paid_by_eisai": 712.43
    },
    {
      "period": "Nov-16",
      "receipts": 11,
      "total": 65293,
      "paid_by_insurers": 59455.21,
      "copay": 5837.79,
      "paid_by_patient": 278.42,
      "paid_by_eisai": 5559.37
    },
    {
      "period": "Dec-16",
      "receipts": 12,
      "total": 60047.05,
      "paid_by_insurers": 57025.9,
      "copay": 3021.15,
      "paid_by_patient": 185.83,
      "paid_by_eisai": 2835.32
    },
    {
      "period": "Jan-17",
      "receipts": 14,
      "total": 80114.12,
      "paid_by_insurers": 71737.81,
      "copay": 8376.31,
      "paid_by_patient": 305.19,
      "paid_by_eisai": 8071.12
    },
    {
      "period": "Feb-17",
      "receipts": 7,
      "total": 47335.51,
      "paid_by_insurers": 42543.63,
      "copay": 4791.88,
      "paid_by_patient": 360.64,
      "paid_by_eisai": 4431.24
    },
    {
      "period": "Mar-17",
      "receipts": 15,
      "total": 90385.04,
      "paid_by_insurers": 82789.64,
      "copay": 7595.4,
      "paid_by_patient": 371.66,
      "paid_by_eisai": 7223.74
    },
    {
      "period": "Apr-17",
      "receipts": 11,
      "total": 62557.37,
      "paid_by_insurers": 54139.88,
      "copay": 8417.49,
      "paid_by_patient": 390.75,
      "paid_by_eisai": 8026.74
    },
    {
      "period": "May-17",
      "receipts": 23,
      "total": 109817.91,
      "paid_by_insurers": 100440.2,
      "copay": 9377.71,
      "paid_by_patient": 69.56,
      "paid_by_eisai": 8937.82
    },
    {
      "period": "Jun-17",
      "receipts": 13,
      "total": 67133.46,
      "paid_by_insurers": 60723.42,
      "copay": 6410.04,
      "paid_by_patient": 170.66,
      "paid_by_eisai": 6239.38
    },
    {
      "period": "Jul-17",
      "receipts": 12,
      "total": 72261.85,
      "paid_by_insurers": 67162.21,
      "copay": 5099.64,
      "paid_by_patient": 85.01,
      "paid_by_eisai": 5014.63
    },
    {
      "period": "Aug-17",
      "receipts": 15,
      "total": 76569.31,
      "paid_by_insurers": 68756.82,
      "copay": 7812.49,
      "paid_by_patient": 267.37,
      "paid_by_eisai": 7545.12
    },
    {
      "period": "Sep-17",
      "receipts": 14,
      "total": 62796.21,
      "paid_by_insurers": 57664.69,
      "copay": 5131.52,
      "paid_by_patient": 176.46,
      "paid_by_eisai": 4955.06
    },
    {
      "period": "Oct-17",
      "receipts": 11,
      "total": 49461.46,
      "paid_by_insurers": 46367.09,
      "copay": 3094.37,
      "paid_by_patient": 170.66,
      "paid_by_eisai": 2923.71
    },
    {
      "period": "Nov-17",
      "receipts": 14,
      "total": 65062.94,
      "paid_by_insurers": 59611.2,
      "copay": 5451.74,
      "paid_by_patient": 255.67,
      "paid_by_eisai": 5196.07
    },
    {
      "period": "Dec-17",
      "receipts": 15,
      "total": 74131.15,
      "paid_by_insurers": 68532.17,
      "copay": 5598.98,
      "paid_by_patient": 170.66,
      "paid_by_eisai": 5428.32
    }
  ];

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProgramHcpPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/program-hcp/program-hcp.ts